import React from 'react';
import withHeader from "../../hocs/withHeader";
import withFooter from "../../hocs/withFooter";

function LandingPage(){
    return(<div className="container"></div>)
}

export default withHeader(withFooter(LandingPage));